module.exports = __webpack_public_path__ + "static/img/ddf7c449a9daf3a93611b2ff8c2cfc03.d99edb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ddf7c449a9daf3a93611b2ff8c2cfc03.png
// module id = xFcS
// module chunks = 29